import React, { useEffect } from 'react'
import SelectedCarBlock from '../../components/selectedCarBlock';
import { rawDataNumberPlates } from '../../constants/rowData.constants';
import { useSelector, useDispatch } from 'react-redux';
import { setNumberPlate,setActiveUrl, setZoomModelVisibility } from '../../redux/slices/carrommSlice';
import { useCarromm } from '../../context/carromm';
import Heading from '../../components/heading/Heading';

const NumberPlate = () => {
  const { number_plate } = useSelector(state => state.carromm);

  const dispatch = useDispatch();
  const carrom = useCarromm();

  const handleNext = () => {
    carrom.setTabs(carrom.tabs.map((t) => ({ ...t, active: t.id === 'show-result' })));
  };

  useEffect(() => {
    dispatch(setNumberPlate({
      "name": "No Mask",
      "id": "0",
      "thumbnail": ""
    }));
  },[]);

  return (
    <>
      <Heading/>
      <div className="select-background-block">
        <div className="bg-list">
          <ul>
            {rawDataNumberPlates &&
              Array.isArray(rawDataNumberPlates) &&
              rawDataNumberPlates?.map((item, index) => (
                <li
                  key={item?.id || index}
                  className={item.isSelected || number_plate?.id === item?.id ? "selected-bg" : 'hover-class'}
                  style={{ cursor: "pointer" }}
                  title="Double click to zoom"
                  onClick={() => {dispatch(setNumberPlate(item));dispatch(setActiveUrl(item?.thumbnail))}}
                  onDoubleClick=
                  {() => {
                    dispatch(setZoomModelVisibility(true));
                  }}>
                  {item?.thumbnail ? <img
                    src={item?.thumbnail}
                    alt={item?.thumbnail} /> :
                    <div className='default-list-item'>
                      Keine Maske
                    </div>
                  }

                </li>
              ))}
          </ul>
        </div>
        <SelectedCarBlock
          handleNext={handleNext} />
      </div>
    </>
  )
}

export default NumberPlate
